import { useReveal } from "../lib/useReveal";

const stories = [
  {
    title: "Kesar, the calf who refused to give up",
    date: "Oct 2024",
    excerpt:
      "Found abandoned near a highway with a fractured leg, Kesar underwent three surgeries. Today she stands beside her mother at dawn.",
    img: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/vwp5tm5d_WhatsApp%20Image%202026-04-24%20at%204.05.20%20PM.jpeg",
  },
  {
    title: "Rescuing five Nilgai deer from a shrinking forest",
    date: "Aug 2024",
    excerpt:
      "A late-night call brought our rescue team to a patch of felled woods. Five Nilgai deer now rehabilitate in our secluded enclosure.",
    img: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/dpygh0ia_WhatsApp%20Image%202026-04-25%20at%2012.11.57%20AM.jpeg",
  },
  {
    title: "A quiet corner for 32 rabbits",
    date: "Mar 2024",
    excerpt:
      "Rescued from illegal trade, a warren of 32 rabbits now thrives in our rehabilitation centre — fed, groomed and photographed daily.",
    img: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/kykpvedl_WhatsApp%20Image%202026-04-24%20at%204.05.20%20PM%20%281%29.jpeg",
  },
];

export default function Stories() {
  const ref = useReveal();
  return (
    <section
      id="stories"
      data-testid="stories-section"
      className="py-24 md:py-32 bg-[#F4F1EA]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div ref={ref} className="reveal max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-[#D4AF37]" />
            <span className="text-xs tracking-[0.3em] uppercase text-[#4A5D53]">
              Rescue stories
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A2E24] leading-[1.05]">
            Every life here has a <span className="italic text-[#1B4D3E]">story</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {stories.map((s, i) => (
            <article
              key={i}
              data-testid={`story-card-${i}`}
              className="group rounded-2xl overflow-hidden bg-[#FDFBF7] border border-[#E3DECE] hover:-translate-y-1 transition-all duration-500 hover:shadow-[0_20px_40px_-20px_rgba(27,77,62,0.25)]"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-[1.06]"
                />
              </div>
              <div className="p-7">
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
                  {s.date}
                </div>
                <h3 className="mt-3 font-display text-2xl text-[#1A2E24] leading-snug">
                  {s.title}
                </h3>
                <p className="mt-3 text-[#4A5D53] leading-relaxed text-sm">
                  {s.excerpt}
                </p>
                <a
                  href="#contact"
                  className="mt-5 inline-flex text-sm text-[#1B4D3E] border-b border-[#D4AF37] hover:text-[#D4AF37] pb-0.5"
                >
                  Read full story
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
